import React, { useContext, useState } from "react";
import { MobileContext, withModal } from "components/common";
import classnames from "classnames";
import { capitalize } from "@tomocredit/common-fe/utils";
import SmartPay from "./SmartPay";
import PaymentSettingsModal from "../../../../../../Popups/Modals/PaymentSettingsModal.js";

function PaymentSettingListItem({ value }) {
  return (
    <div className="flex justify-start py-2">
      <div>
        <div className="mb-1 capitalize inline-block">{value}</div>
      </div>
    </div>
  );
}

function PaymentSettings({
  user,
  handlePaymentSettingsChanged,
  handleSmartPayMethodChanged,
  handleSmartPaySettingsChanged,
  disabledSmartPayPaymentMethodIds = [],
  inProgress,
  roles,
  showSmartPay,
  modalContext: { openModal, closeModal }
}) {
  const { isMobile } = useContext(MobileContext);
  const elements = [
    { value: "Monthly" },
    { value: "Weekly" },
    { value: "Biweekly" }
  ];
  const defaultSelectedElement = user.autopay_frequency
    ? { value: capitalize(user.autopay_frequency) }
    : null;
  const [selectedElement, setSelectedElement] = useState(
    defaultSelectedElement
  );

  const smartPayAccounts = (
    user.payment_methods.filter(
      m => !disabledSmartPayPaymentMethodIds.includes(m.id) && !m.unlinked
    ) || []
  ).map(m => {
    const { __typename, relink_id, unlinked, ...rest } = m;
    return { ...rest };
  });

  const { secondary_payment_method_id: secondary } = user;

  const initialPaymentMethodId = disabledSmartPayPaymentMethodIds.includes(
    secondary
  )
    ? null
    : secondary;

  return (
    <div
      className={classnames({
        "px-10 border- flex-1": !isMobile
      })}
    >
      <p className="font-bold">Autopay Setting:</p>
      <div className={`py-2 ${isMobile ? "mb-6" : "w-3/4"}`}>
        <div
          className={`${
            roles.admin ? "border-b" : ""
          } pt-2 pb-6 flex justify-between`}
        >
          <span
            className="flex items-center tooltip"
            style={{ borderBottom: 0 }}
          >
            {/* <i className="fas fa-lock text-red-500 mr-2" /> */}
            <span>Weekly</span>
            {/* <span className="tooltiptext2 text-sm border" style={{ left: -40 }}>
              This setting is currently locked
            </span> */}
          </span>
          {/* <button
            className="underline"
            type="button"
            onClick={e => {
              openModal(e, "PaymentSettingsModal", { closeModal });
            }}
          >
            More Info
          </button> */}
        </div>
        {/* <Dropdown
          elements={elements}
          selectedElement={selectedElement}
          component={props => <PaymentSettingListItem {...props} />}
          didSelect={el => {
            setSelectedElement(el);
            handlePaymentSettingsChanged(el);
          }}
          disabled={inProgress || true} // re-remove when "weekly" isn't forced
        /> */}
        {(roles.admin || showSmartPay) && (
          <div className="pt-6">
            <SmartPay
              accounts={smartPayAccounts}
              initialPaymentMethodId={initialPaymentMethodId}
              enabled={user.smart_pay || false}
              onToggle={handleSmartPaySettingsChanged}
              onSelect={handleSmartPayMethodChanged}
            />
          </div>
        )}
      </div>
      {/* <p>
        <button className="underline" onClick={e => {
          openModal(e, "PaymentSettingsModal", {closeModal});
        }}>Click here</button>
        {" "} to request more autopay options</p> */}
    </div>
  );
}

export default withModal(PaymentSettings);
